<template>
  <div id="app">
    <!--<transition :name="hasKeep">-->
    <!--<transition>-->
    <!--<keep-alive include="teachCheck">-->
    <keep-alive :include="cacheArr">
      <router-view class="m-router"/>
    </keep-alive>
    <!--</transition>-->

    <m-tabbar :tabData="tabData"></m-tabbar>
    <div class="m-cover-ff" v-if="isBol">
      <img v-if="!isPcBol" src="./assets/img/home/Group8449.png" alt="">
      <p v-if="isPcBol" class="m-cc">请复制下方链接在手机浏览器上打开</p>
      <p v-if="isPcBol" class="m-url m-cc">{{urlPc}}</p>
      <p></p>
    </div>
    <!--悬浮按钮-->
    <div id="item_box" class="m-back-home" v-if="!$route.meta.goHome" @touchstart="down" @touchmove="move" @touchend="end">
      <img @click="$router.push('/examHOme')" src="./assets/img/login/Group1128.png" alt="">
    </div>
  </div>
</template>

<script>
  //  import Vue from 'vue'
  //  import { Tabbar, TabbarItem, NavBar } from 'vant'
  import MTabbar from '@/components/tabbar/m-tabbar'
  import keepAliveRoute from '@/router/keepAliveRoute'
  //  Vue.use(Tabbar).use(TabbarItem).use(NavBar)
  export default {
    name: 'app',
    components: {MTabbar},
    data () {
      return {

        cacheArr: [],
//        active: 0,
        hasKeep: 'slide-left',
        tabData: [
          {
            name: '考试报名',
            path: '/examHome',
            iconPath: require('@/assets/img/tabbar/Group 749@2x.png'),
            selectedIconPath: require('@/assets/img/tabbar/Group 744@2x.png')
          },
          {
            name: '帮助中心',
            path: '/news',
            iconPath: require('@/assets/img/tabbar/Group 745@2x.png'),
            selectedIconPath: require('@/assets/img/tabbar/Group 748@2x.png')
          },
          {
            name: '个人中心',
            path: '/mySelf',
            iconPath: require('@/assets/img/tabbar/Group 746@2x.png'),
            selectedIconPath: require('@/assets/img/tabbar/Group 747@2x.png')
          }
        ],
        isBol: false,
        isIosMoveBack: false, // 判断过度动画取消的时机
        isPcBol: false,
        urlPc: window.location.origin,
        showWechat: false,
        flags: false,
        position: { x: 0, y: 0 },
        nx: "",
        ny: "",
        dx: "",
        dy: "",
        xPum: "",
        yPum: "",
        isVibe:process.env.NODE_ENV
      }
    },
    created () {
      this.cacheArr = keepAliveRoute
      if (window.location.pathname != '/payPage' && window.location.pathname != '/goodHome' && window.location.pathname != '/autoPage') {
        this.getTenant()
      }
    },
    methods: {
      getTenant () {
        this.http.getRequest({
          url: 'app/userInfo/tenantNoLogin',
          msg: {},
          success: (res) => {
            this.showWechat = (res.data && res.data.showWechat == 1) ? true : false
            this.isModel()
          }
        })
      },
      isModel () {
        if (this.utils.isWeixin() || this.utils.isZhiFuBai() || this.isQQ()) {
          if (this.utils.isWeixin() && this.showWechat) {
            this.isBol = false
          } else {
            this.isBol = true
          }
        } else {
          this.isBol = false
          this.isPcBol = false
          this.isPc()
        }
      },
      // 是否ios
      isIOS () {
        let u = navigator.userAgent //获取到的是个字符串，包括很多信息，我只匹配我想要的信息
        return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //判断是苹果手机
      },
      // 是否qq内置浏览器
      isQQ () {
        const ua = window.navigator.userAgent.toLowerCase()
        if ((this.utils.getDeviceOS() === 'ios') && (/ QQ/i.test(ua))) {
          return true
        }
        if ((this.utils.getDeviceOS() === 'android') && (/MQQBrowser/i.test(ua)) && (/ QQ/i.test((ua).split('MQQBrowser')))) {
          return true
        }
      },
      //是否在pc端
      isPc () {
        if(this.isVibe=='development'){
          return
        }
        var system = {}
        var p = navigator.platform
        var u = navigator.userAgent
        system.win = p.indexOf('Win') == 0
        system.mac = p.indexOf('Mac') == 0
        system.x11 = p == 'X11' || p.indexOf('Linux') == 0
        if (system.win || system.mac || system.xll) {
          //如果是PC转
          this.isBol = true
          this.isPcBol = true
        }
      },
      // 实现移动端拖拽
      down() {
        let item_box = document.querySelector("#item_box");
        this.flags = true;
        var touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.maxW = document.body.clientWidth - item_box.offsetWidth;
        this.maxH = document.body.clientHeight - item_box.offsetHeight;

        this.position.x = touch.clientX - item_box.offsetLeft;
        this.position.y = touch.clientY - item_box.offsetTop;
        this.dx = touch.clientX;
        this.dy = touch.clientY;
      },
      move(event) {
        event.preventDefault();
        let item_box = document.querySelector("#item_box");
        if (this.flags) {
          var touch;
          if (event.touches) {
            touch = event.touches[0];
          } else {
            touch = event;
          }
          this.nx = touch.clientX - this.position.x;
          this.ny = touch.clientY - this.position.y;

          if (this.nx < 0) {
            this.nx = 0;
          } else if (this.nx > this.maxW) {
            this.nx = this.maxW;
          }

          if (this.ny < 0) {
            this.ny = 0;
          } else if (this.ny >= this.maxH) {
            this.ny = this.maxH;
          }

          item_box.style.left = this.nx + "px";
          item_box.style.top = this.ny + "px";
          document.addEventListener(
            "touchmove",
            function () {
              // event.preventDefault()
            },
            false
          );
        }
      },
      //鼠标释放
      end() {
        this.flags = false;
      },
    },
    mounted () {
      // 判断机型（IOS时返回true)
//      if (this.isIOS()){
//        // 监听到滑动事件时设为true
//        document.body.addEventListener('touchmove', () => {
//          this.isIosMoveBack = true
//        }, false)
//      }
//      this.isPc()
    },
    watch: {
//      $route (to, from) {
//        // 监听路由变化时的状态为前进还是后退
//        if (to.meta.grade && from.meta.grade) {
//          if (to.meta.grade < from.meta.grade) {
//            if(this.isIosMoveBack){
//              this.hasKeep = ''
//              this.isIosMoveBack = false
//            }else {
//              this.hasKeep = 'slide-right'
//            }
//          } else {
//            if(this.isIosMoveBack){
//              this.hasKeep = ''
//              this.isIosMoveBack = false
//            }else {
//              this.hasKeep = 'slide-left'
//            }
//          }
//        } else {
//          let routersArr =
//            (sessionStorage.getItem('routers') &&
//              sessionStorage.getItem('routers').split(',')) ||
//            []
//          if (routersArr.length === 0) {
//            routersArr.push(from.path)
//            routersArr.push(to.path)
//          } else {
//            if (routersArr.indexOf(to.path) !== -1) {
//              if(this.isIosMoveBack){
//                this.hasKeep = ''
//                this.isIosMoveBack = false
//              }else {
//                this.hasKeep = 'slide-right'
//              }
//              routersArr.splice(routersArr.indexOf(to.path) + 1, 100)
//            } else {
//              if(this.isIosMoveBack){
//                this.hasKeep = ''
//                this.isIosMoveBack = false
//              }else {
//                this.hasKeep = 'slide-left'
//              }
//              routersArr.push(to.path)
//            }
//          }
//          sessionStorage.setItem('routers', routersArr.join(','))
//        }
//      }
    }
  }
</script>

<style ref="stylesheet/less" lang="less">
  @import "assets/css/reset.css";
  @import "assets/css/common.less";

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: none;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-size: 14px;
  }

  /*路由动画*/
  .m-router {
    position: absolute;
    width: 100%;
    transition: all 0.5s ease;
  }

  .slide-left-enter,
  .slide-right-leave-active {
    opacity: 0;
    -webkit-transform: translate(100%, 0);
    transform: translate(100%, 0);
  }

  .slide-left-leave-active,
  .slide-right-enter {
    opacity: 0;
    -webkit-transform: translate(-100%, 0);
    transform: translate(-100% 0);
  }

  .m-cover-ff {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: #4F5664;
    z-index: 1000;
    > img {
      width: 238px;
      height: 221px;
      position: absolute;
      right: 23px;
      top: 23px;
    }
    .m-cc {
      font-size: 18px;
      margin-top: 40%;
      color: #ffffff;
      text-align: center;
    }
    .m-url {
      margin-top: 25px;
      color: #3E8BF6;
    }
  }
  .m-back-home{
    position: absolute;
    bottom: 80px;
    right: 8px;
    z-index:1;
    width: 60px;
    height: 60px;
    >img{
      width: 100%;
      height: 100%;
    }
  }
</style>
